import {RouteLocationNormalizedLoaded} from 'vue-router';

type SeoConfig = {
    title?: string;
    description?: string;
    image?: string;
    path?: string;
    robots?: string;
};

const SITE_NAME = process.env.VUE_APP_NAME || 'สลากมหาเฮง';
const SITE_URL = normalizeSiteUrl(process.env.VUE_APP_SITE_URL || 'https://xn--12cm1foyjv2ad4l.com');
const DEFAULT_DESCRIPTION = 'ซื้อสลากดิจิทัลออนไลน์ ค้นหาเลขเด็ด ตรวจผลรางวัล และจัดการสลากของคุณกับสลากมหาเฮง';
const DEFAULT_IMAGE = '/assets/icon/icon.png';

function normalizeSiteUrl(url: string) {
    return url.replace(/\/+$/, '');
}

function absoluteUrl(path: string) {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    return new URL(path || '/', SITE_URL).toString();
}

function setMeta(name: string, content: string, attribute = 'name') {
    let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement | null;

    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
    }

    element.setAttribute('content', content);
}

function setCanonical(url: string) {
    let element = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (!element) {
        element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        document.head.appendChild(element);
    }

    element.setAttribute('href', url);
}

export function updateSeo(route: RouteLocationNormalizedLoaded) {
    const seo = (route.meta?.seo || {}) as SeoConfig;
    const title = seo.title || SITE_NAME;
    const description = seo.description || DEFAULT_DESCRIPTION;
    const canonicalUrl = absoluteUrl(seo.path || route.path || '/');
    const imageUrl = absoluteUrl(seo.image || DEFAULT_IMAGE);
    const robots = seo.robots || 'index,follow';

    document.title = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

    setMeta('description', description);
    setMeta('robots', robots);
    setMeta('theme-color', '#f4f5f8');

    setCanonical(canonicalUrl);

    setMeta('og:site_name', SITE_NAME, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:url', canonicalUrl, 'property');
    setMeta('og:title', document.title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:image', imageUrl, 'property');
    setMeta('og:locale', 'th_TH', 'property');

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', document.title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', imageUrl);
}
